module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"modal-dialog modal-lg carrier-account\"> <div class=\"modal-content p-0\"> <section class=\"modal-header\"> <h3 class=\"modal-title\">Create Shipment</h3> <button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span>&times;</span></button> </section> <section class=\"modal-body\"> <div class=\"row\"> <div class=\"modal-tabs col-sm-4\"></div> <div class=\"col-sm-8\"> <div class=\"tab-content\"> <div class=\"tab-pane fade show active\" id=\"shipment-create-step0\" role=\"tabpanel\"> <h6>To Address <small>(required)</small></h6> <div class=\"to-address-form\" data-model=\"to_address\"></div> </div> <div class=\"tab-pane fade\" id=\"shipment-create-step1\" role=\"tabpanel\"> <h6>From Address <small>(required)</small></h6> <div class=\"from-address-form\" data-model=\"from_address\"></div> </div> <div class=\"tab-pane fade\" id=\"shipment-create-step2\" role=\"tabpanel\"> <h6>Return Address <small>(optional)</small></h6> <div class=\"return-address-form\" data-model=\"return_address\"></div> </div> <div class=\"tab-pane fade\" id=\"shipment-create-step3\" role=\"tabpanel\"> <h6>Parcel <small>(required)</small></h6> <div class=\"parcel-form\" data-model=\"parcel\"></div> </div> <div class=\"tab-pane fade\" id=\"shipment-create-step4\" role=\"tabpanel\"> <h6>Customs Info <small>(if international)</small></h6> <div class=\"customs-info-form\" data-model=\"customs_info\"></div> </div> <div class=\"tab-pane fade\" id=\"shipment-create-step5\" role=\"tabpanel\"> <div class=\"shipment-form\" data-model=\"shipment\"></div> </div> <div class=\"tab-pane fade\" id=\"shipment-create-step6\" role=\"tabpanel\"> <div class=\"choose-label\"></div> </div> </div> </div> </div> </section> <section class=\"modal-footer\"> <button class=\"btn btn-secondary create_shipment\" type=\"submit\">Next</button> </section> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/shipments/create/modal/template.ejs
// module id = 1824
// module chunks = 1